export default __webpack_public_path__ + "static/media/information--recreational-vehicle-sanitary-station--g1.e0780834.png";